import type { Settlement } from '../engine/map/settlement';
import { getGameConfig } from '../config/gameConfig';
import { applyConstructionComplete } from '../engine/economy/construction';

export function runConstructionTick(settlement: Settlement): boolean {
    if (settlement.jobs.builders <= 0) return false;
    if (settlement.construction.queue.length === 0) return false;

    const workPerTick = getGameConfig().production.builderWorkPerTick;
    let remaining = settlement.jobs.builders * workPerTick;
    let changed = false;

    while (remaining > 0 && settlement.construction.queue.length > 0) {
        const item = settlement.construction.queue[0];
        const needed = item.workRequired - item.work;
        if (needed <= 0) {
            applyConstructionComplete(settlement, item.building);
            settlement.construction.queue.shift();
            changed = true;
            continue;
        }
        const used = Math.min(remaining, needed);
        item.work += used;
        remaining -= used;
        changed = true;
        if (item.work >= item.workRequired) {
            applyConstructionComplete(settlement, item.building);
            settlement.construction.queue.shift();
            changed = true;
        }
    }

    return changed;
}
